import { combineReducers } from "redux";
import { quotaLimits } from "./quotaLimits";
import { sessions } from "./sessions";

export const local = combineReducers({
  sessions,
  quotaLimits,
});
